import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface SemanticTriplet {
  subject: string;
  predicate: string;
  object: string;
  context?: string;
}

export interface RecognitionItem {
  id: string;
  title: string;
  organization: string;
  badge: string;
  scope: string;
  logoUrl: string;
  description: string;
  triplets: SemanticTriplet[];
}

@Component({
  selector: 'app-endorsements',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './endorsements.html',
  styleUrl: './endorsements.scss',
})
export class Endorsements {
  readonly recognitions: RecognitionItem[] = [
    {
      id: 'asociacion-ronmeliers',
      title: 'Asociación Iberoamericana de Ronmeliers',
      organization: 'Asociación Iberoamericana de Ronmeliers',
      badge: 'Reconocimiento Oficial',
      scope: 'Iberoamérica',
      logoUrl: 'https://qgbwjkjgnyaynctlqxvq.supabase.co/storage/v1/object/public/views/AsociacionIberoamericanaRommeliers.webp',
      description: 'Estancos Distilling Company cuenta con el reconocimiento oficial de la Asociación Iberoamericana de Ronmeliers por su maestría en la destilación artesanal y crianza de rones de altura a 2500 msnm.',
      triplets: [
        {
          subject: 'Estancos Distilling Company',
          predicate: 'es reconocida por',
          object: 'la Asociación Iberoamericana de Ronmeliers',
          context: 'Excelencia en destilación y crianza andina'
        },
        {
          subject: 'Ron Legarda de Estancos',
          predicate: 'cumple con los estándares sensoriales de',
          object: 'Maestros Ronmeliers Iberoamericanos',
          context: 'Análisis organoléptico y pureza'
        }
      ]
    },
    {
      id: 'whisky-ambassador',
      title: 'Whisky Ambassador',
      organization: 'The Whisky Ambassador (Reino Unido)',
      badge: 'Certificación Internacional',
      scope: 'Global / UK Accredited',
      logoUrl: 'https://qgbwjkjgnyaynctlqxvq.supabase.co/storage/v1/object/public/views/whiskyAmbassador_2.png',
      description: 'Estancos Distilling Company está acreditada bajo el programa Whisky Ambassador del Reino Unido, garantizando los más altos estándares internacionales en conocimiento, cata y elaboración de whisky.',
      triplets: [
        {
          subject: 'Estancos Distilling Company',
          predicate: 'está acreditada por',
          object: 'The Whisky Ambassador Programme',
          context: 'Capacitación y estándares de whisky de origen británico'
        },
        {
          subject: 'Whisky Real Audiencia',
          predicate: 'es evaluado bajo los lineamientos de',
          object: 'Whisky Ambassador Certified Experts',
          context: 'Añejamiento y caracterización sensorial'
        }
      ]
    }
  ];

  onImageError(event: Event, fallbackType: 'ron' | 'whisky'): void {
    const target = event.target as HTMLImageElement;
    if (fallbackType === 'ron') {
      target.src = 'https://qgbwjkjgnyaynctlqxvq.supabase.co/storage/v1/object/public/views/AsociacionIberoamericanaRommeliers.webp';
    } else {
      target.src = 'https://qgbwjkjgnyaynctlqxvq.supabase.co/storage/v1/object/public/views/whiskyAmbassador_2.png';
    }
  }
}
